import { useEffect } from 'react';
import { buildComponentDocsPath, logToConsole } from '../util';
import { usePrevious } from './usePrevious';
/**
 * A hook that warns if its component has switched from controlled to uncontrolled.
 *
 * @private
 */
export function useControlledStateWarning(value, _a) {
    var _b = _a === void 0 ? {} : _a, displayName = _b.displayName, _c = _b.docsPath, docsPath = _c === void 0 ? true : _c, _d = _b.stringifiedNullValue, stringifiedNullValue = _d === void 0 ? 'null' : _d;
    var prevValue = usePrevious(value);
    useEffect(function () {
        if (prevValue !== undefined && value === undefined) {
            logToConsole([
                'An instance of this component has switched from controlled to uncontrolled. Correctness is not guaranteed when this happens.',
                "Use `".concat(stringifiedNullValue, "` as the null value, NOT `undefined`."),
            ].join(' '), {
                displayName: displayName,
                docsPath: docsPath === true ? (displayName ? buildComponentDocsPath(displayName, 'props') : undefined) : docsPath,
                level: 'warn',
            });
        }
    }, [displayName, docsPath, prevValue, stringifiedNullValue, value]);
}
